<template>
  <b-form-group
    label="Kategori"
    label-for="id_corporate_policies_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Kategori"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_corporate_policies_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CorporatePoliciesCategoriesCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['corporatePoliciesCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('corporatePoliciesCategories/getDataList', {
        select: [
          'corporate_policies_categories.id AS id',
          'corporate_policies_categories.title AS title',
        ],
      })
    },
  },
}
</script>
